declare global {
  interface Window {
    clarity?: (method: string, ...args: string[]) => void;
  }
}

export function trackEvent(name: string): void {
  try {
    window.clarity?.("event", name);
  } catch {
    // Clarity not loaded — silently ignore
  }
}
